export const customThemeVariables = {
  '--sjs-layer-1-background-500': '#FFFFFFFF',
  '--sjs-layer-1-background-400': '#f0f3ff',
  '--sjs-layer-1-foreground-100': '#222',
  '--sjs-layer-1-foreground-50': '#222',
  '--sjs-layer-3-background-500': '#fff',
  '--sjs-layer-3-foreground-100': '#222',
  '--sjs-layer-3-foreground-50': '#6a7282',
  '--sjs-layer-2-background-500': '#fff',
  '--sjs-layer-2-background-400': '#DAE2F7FF',
  '--sjs-border-25': '#e5e7eb',
  '--sjs-border-10': '#e5e7eb',
  '--sjs-primary-background-500': '#3853C4',
  '--sjs-primary-background-10': '#f0f3ff',
  '--sjs-primary-background-400': '#3853C4',
  '--sjs-primary-foreground-100': '#fff',
  '--sjs-primary-foreground-25': '#fff',
  '--sjs-secondary-background-500': '#3853C4',
  '--sjs-secondary-background-25': '#d6e3ff',
  '--sjs-secondary-background-10': '#f0f3ff',
  '--sjs-secondary-foreground-100': '#fff',
  '--sjs-secondary-forecolor-25': '#fff',
  '--sjs-semantic-red-background-500': '#c10007',
  '--sjs-semantic-red-background-10': '#fef2f2',
  '--sjs-semantic-red-foreground-100': '#FFFFFFFF',
  '--sjs-semantic-green-background-500': '#19B394FF',
  '--sjs-semantic-green-background-10': '#19B3941A',
  '--sjs-semantic-green-foreground-100': '#FFFFFFFF',
  '--sjs-semantic-blue-background-500': '#437FD9FF',
  '--sjs-semantic-blue-background-10': '#437FD91A',
  '--sjs-semantic-blue-foreground-100': '#FFFFFFFF',
  '--sjs-semantic-yellow-background-500': '#FF9814FF',
  '--sjs-semantic-yellow-background-10': '#FF98141A',
  '--sjs-semantic-yellow-foreground-100': '#FFFFFFFF',
  '--sjs-semantic-white-background-500': '#FFFFFFFF',
  '--sjs-code-gray-700': '#B6B6B6FF',
  '--sjs-code-blue-500': '#326FCAFF',
  '--sjs-code-gray-300': '#505050FF',
  '--sjs-code-green-500': '#08997CFF',
  '--sjs-code-red-500': '#c10007',
  '--sjs-code-purple-500': '#C22FA2FF',
  '--sjs-code-yellow-500': '#F58D06FF',
  '--sjs-code-gray-500': '#8A8A8AFF',
  '--sjs-special-background': '#fafafa',
  '--sjs-layer-1-foreground-75': '#3853C4',
  '--sjs-layer-3-background-400': '#f0f3ff',
  '--sjs-special-glow': '#27385933',
  '--sjs-special-shadow': '#27385940',
  '--sjs-layer-3-foreground-75': '#0930A0FF',
  '--sjs-layer-2-foreground-100': '#273859FF',
  '--sjs-layer-2-foreground-75': '#0930A0FF',
  '--sjs-layer-2-foreground-50': '#26335880',
  '--sjs-border-25-overlay': '#00000026',
  '--sjs-secondary-background-400': '#C62076FF',
  '--ctr-surface-button-corner-radius': '24px',
  '--ctr-button-corner-radius-small': '24px'
};
